import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=2d9a0979&scoped=true&"
import script from "./ReservationCard.vue?vue&type=script&lang=js&"
export * from "./ReservationCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&id=2d9a0979&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a0979",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VIcon,VRow})
